import React from 'react'


const Tabs = ({ tabs, currentTab, setCurrentTab }) => {

    return (<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', margin: '10px 0' }}>
        {tabs.map(tab => <button key={tab} style={currentTab !== tab ? { color: '#FF7100', backgroundColor: 'white', padding: '10px' } : { marginRight: '10px', padding: '10px' }} onClick={() => setCurrentTab(tab)}>{tab}</button>)}
    </div>)
}

export default Tabs